import React, { Component } from "react";

export default class Header extends Component {
    render() {
        return(
            <>
            <header className="header">
                
            </header>
            <div className="wave"></div>
            </>
        )
    }
}